import classNames from "classnames";
import { ErrorWrapper } from "../../../components/Error/ErrorWrapper.tsx";

export const OptionsLayout = ({
  children,
  errors,
}: {
  children: React.ReactNode;
  errors: string[];
}) => (
  <ErrorWrapper errors={errors}>
    <div
      className={classNames(
        "w-[800px] grid grid-cols-2 gap-400 rounded-150 p-200",
        errors.length > 0 && "outline-error",
      )}
    >
      {children}
    </div>
  </ErrorWrapper>
);
